import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import MKBox from 'components/MaterialKit/MKBox';
import EditAppForm from 'pages/AppSummary/EditAppForm';
import { handleErrorResponse } from 'utils/general';
import { getApp, updateApp } from 'api/apps';
import { useAuth } from 'contexts/auth';
import PageSection from './PageSection';
import MenuSection from './MenuSection';
import LanguageSection from './LanguageSection';
import LayoutSection from './LayoutSection';

const AppSummaryPage = () => {
  const [app, setApp] = useState(null);
  const { appId } = useParams();
  const { setAuth } = useAuth();

  const fetchAppFromApi = useCallback(() => {
    const appParams = {
      $expand: 'solution',
    };
    return getApp(appId, appParams)
      .then(({ data }) => {
        setApp(data);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [appId, setAuth]);

  const updateAppToApi = useCallback((values, { setFieldError }) => {
    const updateBody = {
      display_name: values.display_name,
      base_url: values.base_url,
      major_version: values.major_version,
      minor_version: values.minor_version,
      type: values.type,
    };
    return updateApp(appId, updateBody)
      .then(({ data }) => {
        setApp(data);
      })
      .catch((err) => {
        setFieldError('form', err.message);
      });
  }, [appId]);

  useEffect(() => {
    fetchAppFromApi();
  }, [fetchAppFromApi]);

  return (
    <MKBox flex={1} bgColor="light" py="2rem">
      <Container>
        <EditAppForm
          app={app}
          onSave={updateAppToApi}
        />
        <LanguageSection />
        <LayoutSection />
        <PageSection />
        <MenuSection />
      </Container>
    </MKBox>
  );
};

export default AppSummaryPage;
